import { isEmpty, notEmpty, objectUtils } from '@festina-life/core'
import { Td, Tr } from '@festina-life/ui/listsAndTables'
import { type CSSProperties, Fragment, type JSX } from 'react'

import { DiffObjectCell } from './DiffObjectCell'

type Props<T> = {
  diff: objectUtils.Diff<T>
  depth: number
}

export const DiffObjectRows = <T,>({
  diff,
  depth,
}: Props<T>): JSX.Element | null => {
  if (isEmpty(diff)) {
    return null
  }

  const style = { '--pad': `${depth}em` } as CSSProperties
  const className = 'pl-(--pad)'

  return (
    <>
      {Array.isArray(diff)
        ? diff.filter(notEmpty).map((value, index) =>
            objectUtils.isDiffElement(value) ? (
              // oxlint-disable-next-line react/no-array-index-key -- we don't have a unique key
              <Tr key={index}>
                <Td style={style} className={className}>
                  #{index + 1}
                </Td>
                <DiffObjectCell value={value.removed} />
                <DiffObjectCell value={value.added} />
              </Tr>
            ) : (
              // oxlint-disable-next-line react/no-array-index-key -- we don't have a unique key
              <Fragment key={index}>
                <Tr>
                  <Td style={style} className={className}>
                    #{index + 1}
                  </Td>
                  <Td />
                  <Td />
                </Tr>
                <DiffObjectRows
                  diff={value as NonNullable<objectUtils.Diff<unknown>>}
                  depth={depth + 1}
                />
              </Fragment>
            ),
          )
        : Object.entries(diff).map(([key, value]) =>
            objectUtils.isDiffElement(value) ? (
              <Tr key={key}>
                <Td style={style} className={className}>
                  {key}
                </Td>
                <DiffObjectCell value={value.removed} />
                <DiffObjectCell value={value.added} />
              </Tr>
            ) : (
              <Fragment key={key}>
                <Tr>
                  <Td style={style} className={className}>
                    {key}
                  </Td>
                  <Td />
                  <Td />
                </Tr>
                <DiffObjectRows
                  diff={value as NonNullable<objectUtils.Diff<unknown>>}
                  depth={depth + 1}
                />
              </Fragment>
            ),
          )}
    </>
  )
}
